import Axios from 'axios'

import {
  areAllShipmentsAssigned,
} from '@/services/Helpers'

import {
  standardizeOrder,
  MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing,
} from '@/services/Standardizers'

import { log } from '@/services/Log'
//---------------------------------------------------------------

import {
  getCartFromResponse,
} from '@/services/FramedCheckout/cartServices'
import { recoverShippingOptions } from '@/services/FramedCheckout/shipmentServices'

const standardizeOrderFromResponse=({ bigcResponse, order }) => {
  const cart = getCartFromResponse(bigcResponse?.cart, order)
  return standardizeOrder(bigcResponse, cart)
}

// Updates an existing consignment. - https://developer.bigcommerce.com/api-reference/storefront/checkouts/checkout-consignments/checkoutsconsignmentsbycheckoutidandconsignmentidput
// Shipping address, line item IDs or the shipping option ID can be updated using this endpoint.
export const updateShippingOption = async ({ order, shipmentId, shippingOptionId }) => {
  log('updateShippingOption START', { order, shipmentId, shippingOptionId })
  // TODO: verify if this operation can be using expired consignment IDs
  const { data, status } = await Axios.put(
    `/api/storefront/checkouts/${order?.cart?.id}/consignments/${shipmentId}?include=consignments.availableShippingOptions`,
    { shippingOptionId },
  )
  const newOrder = standardizeOrderFromResponse({ order, bigcResponse: data })
  const allShipmentsAssigned = areAllShipmentsAssigned(newOrder)
  await MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing({ order: newOrder })
  log('updateShippingOption END', { success: status === 200, newOrder, areAllShipmentsAssigned: allShipmentsAssigned })
  if (!allShipmentsAssigned) {
    return await recoverShippingOptions({ order, newOrder })
  }
  return { success: status === 200, newOrder }
}
